// @flow
import { connect } from 'react-redux';
import type { State, PlaneEntity } from '../../../types';
import { sessionConfigSelector } from '../../../selectors/configSelectors';
import { makePlaneEntitySelector } from '../../../selectors/planeSelectors';
import planeActions from '../../../actions/planeActions';
import SyncPlane from '../SyncPlane';
import type { Props } from '../SyncPlane';

type OwnProps = $ReadOnly<{
    icao: string,
    entity: PlaneEntity
}>;

const mapStateToProps = (state: State, props: OwnProps) => {
    const planeBuffer = makePlaneEntitySelector(props.icao)(state);

    return {
        sessionConfig: sessionConfigSelector(state),
        plane: planeBuffer && planeBuffer[0]
    };
};

const mapDispatchToProps = {
    endSession: planeActions.endSession
};

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps, mapDispatchToProps)(SyncPlane);